import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, Fragment } from 'react';
import { useDesignTokens } from '@sas/nova-commons/theme';
import { Icon } from '@sas/nova-commons/components/Icon';
import { InformationStatus } from '@sas/react-svg';
import { Popover } from '@sas/nova-commons/components/Popover';
export const WarningIcon = ({ warning, iconStyle }) => {
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const refIcon = useRef(null);
    const refReturnFocus = useRef(false);
    const dt = useDesignTokens();
    return warning ? (_jsxs(Fragment, { children: [_jsx(Icon, { ref: refIcon, style: iconStyle, tooltip: warning, icon: InformationStatus, onPress: () => {
                    setTooltipVisible(true);
                } }), _jsx(Popover, Object.assign({ focusLockProps: {
                    onDeactivation() {
                        if (refReturnFocus.current) {
                            refReturnFocus.current = false;
                            setTimeout(() => {
                                var _a;
                                (_a = refIcon.current) === null || _a === void 0 ? void 0 : _a.focus();
                            });
                        }
                    },
                }, onEscape: () => {
                    refReturnFocus.current = true;
                }, returnFocus: false, referenceElementRef: refIcon, isOpen: tooltipVisible, placement: "bottom", onClose: () => setTooltipVisible(false), focusable: true, style: {
                    color: dt.reportTokens.text.basic.fg,
                } }, { children: warning }))] })) : null;
};
